export default "__VITE_ASSET__v3Si2ECL__"